export const preloadImages = async srcArray => {
  const promises = await srcArray.map(src => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.addEventListener('load', () => resolve(img));
      img.addEventListener('error', () => reject());

      // Отклонить промис, если изображение не загрузится в течение 10 секунд
      setTimeout(() => reject(new Error('error')), 10000);
    });
  });

  const response = Promise.all(promises)
    .then(() => 'load')
    .catch(() => 'error');

  return response;
};
